import * as yup from "yup";
import { requiredField } from "../../../../../../../common/infrastructure/helpers/yupHelper";

export const renewCardFormSchema = yup
  .object({
    subscriptionId: yup
      .number()
      .typeError(requiredField("Карта"))
      .positive(requiredField("Карта"))
      .required(requiredField("Карта")),
  })
  .required();

export type IRenewCardFormModel = yup.InferType<typeof renewCardFormSchema>;

export const renewCardFormDefaultValues: IRenewCardFormModel = {
  subscriptionId: undefined as unknown as number,
};
